import { graphql } from "@repo/graphql-types/gql";
import Left from "@repo/icons/default/Left";
import { createFileRoute } from "@tanstack/react-router";
import { format } from "date-fns";
import { useEffect, type JSX } from "react";
import {
  HeaderRoot,
  HeaderButton,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { useGraphQL } from "@/hooks/use-graphql";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import { ReservedScheduleList } from "@/components/reserved-schedules/reserved-schedule-list";
import { useResetReservedScheduleDraft } from "@/lib/atoms/reserved-schedule-form-atom";
import { useRecordWizardStop } from "@/lib/reserved-schedules/wizard-history";

const ReservedSchedulesQuery = graphql(/* GraphQL */ `
  query GetPeriodosGarantidosRecorrentesDoUsuario(
    $dataAgendamento: date!
    $horaInicio: time!
  ) {
    ...ReservedScheduleListQueryFragment
  }
`);

const ReservedSchedulesPage = (): JSX.Element => {
  const resetDraft = useResetReservedScheduleDraft();

  // Esta é a única porta de entrada do fluxo de criação: uma tentativa abandonada no meio do
  // caminho deixava um rascunho obsoleto que reaparecia na tentativa seguinte, porque só o caminho
  // de sucesso limpava.
  useEffect(() => {
    resetDraft();
  }, [resetDraft]);
  // Depois do reset, de propósito: o reset também zera os índices gravados, e este é o índice para
  // o qual "Ir para meus períodos" volta no fim do wizard.
  useRecordWizardStop("list");

  const queryResult = useGraphQL(ReservedSchedulesQuery, {
    dataAgendamento: format(new Date(), "yyyy-MM-dd"),
    horaInicio: format(new Date(), "HH:mm"),
  });

  const { data } = queryResult;

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Período garantido" align="center" />
      </HeaderRoot>
      <Page>
        <AsyncDataWrapper {...queryResult}>
          {data ? <ReservedScheduleList reservedScheduleList={data} /> : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/reserved-schedules/")({
  component: ReservedSchedulesPage,
});
